import React from 'react'
import { Route, Routes } from "react-router-dom";
import AccueilContainer from '../container/AccueilContainer' ;
import InscriptionContainer from '../container/InscriptionContainer' ;
import ActualiteContainer from '../container/ActualiteContainer' ;
import Contact from '../composants/Contact' ;
import Perfectionnement from '../composants/Perfectionnement' ;
import PresentationContainer from '../container/PresentationContainer' ;
import EvenementsContainer from '../container/EvenementsContainer' ;
import PratiqueContainer from '../container/PratiqueContainer' ;
import MembresContainer from '../container/MembresContainer' ;
import PilotageStructuresSanitaireContainer from '../container/PilotageStructuresSanitaireContainer' ;
import PilotageContenusContainer from '../container/PilotageContenusContainer' ;
import BanqueRessourcesContainer from '../container/BanqueRessourcesContainer' ;
import GestionDroitsPilotageContainer from '../container/GestionDroitsPilotageContainer';
import ResultatsRechercheContainer from '../container/ResultatsRechercheContainer' ;
import ContenuGeneriqueContainer from '../container/ContenuGeneriqueContainer' ;
import ReinitialiserMotDePasseContainer from '../container/ReinitialiserMotDePasseContainer' ;
import ConfirmerCourrielContainer from '../container/ConfirmerCourrielContainer' ;
import RouteAdminPilotage from '../composants/RouteAdminPilotage';
import AccesRefusePilotage from '../composants/AccesRefusePilotage';
import RouteAuthentifiee from '../composants/RouteAuthentifiee';
import AccesRefuseConnexion from '../composants/AccesRefuseConnexion';

const RouteNavigation = () => { 
    return(       
        <div>
            <Routes>
                    <Route path="/" element={<AccueilContainer />} />
                    <Route path="/presentation" element={<PresentationContainer />} />
                    <Route path="/actualites" element={<ActualiteContainer />} />
                    <Route path="/profession" element={<PratiqueContainer />} />
                    <Route path="/perfectionnement" element={<Perfectionnement />} />
                    <Route
                        path="/devmembre"
                        element={
                            <RouteAuthentifiee>
                                <InscriptionContainer />
                            </RouteAuthentifiee>
                        }
                    />
                    <Route path="/contact" element={<Contact />} />
                    <Route
                        path="/nosmembres"
                        element={
                            <RouteAuthentifiee>
                                <MembresContainer />
                            </RouteAuthentifiee>
                        }
                    />
                    <Route
                        path="/pilotage-structures-sanitaires"
                        element={
                            <RouteAdminPilotage>
                                <PilotageStructuresSanitaireContainer />
                            </RouteAdminPilotage>
                        }
                    />
                    <Route
                        path="/pilotage-contenus"
                        element={
                            <RouteAdminPilotage>
                                <PilotageContenusContainer />
                            </RouteAdminPilotage>
                        }
                    />
                    <Route
                        path="/gestion-droits-pilotage"
                        element={
                            <RouteAdminPilotage>
                                <GestionDroitsPilotageContainer />
                            </RouteAdminPilotage>
                        }
                    />
                    <Route
                        path="/pilotage-ressources-categories"
                        element={
                            <RouteAdminPilotage>
                                <BanqueRessourcesContainer />
                            </RouteAdminPilotage>
                        }
                    />
                    <Route path="/evenements" element={<EvenementsContainer />} />
                    <Route path="/contenu-generique" element={<ContenuGeneriqueContainer />} />
                    <Route path="/recherche" element={<ResultatsRechercheContainer />} />
                    <Route path="/reinitialiser-mot-de-passe" element={<ReinitialiserMotDePasseContainer />} />
                    <Route path="/confirmer-courriel" element={<ConfirmerCourrielContainer />} />
                    <Route path="/acces-refuse-pilotage" element={<AccesRefusePilotage />} />
                        <Route path="/acces-refuse-connexion" element={<AccesRefuseConnexion />} />
            </Routes>
        </div>                      
    );    
}

export default RouteNavigation;
